export const MARITAL_STATUS_MODEL = "marital-status";

const maritalStatusModel = {
  name: ""
};

export default maritalStatusModel;
